import React from "react";
import SelectAutocomplete from "common/SelectAutocomplete.jsx";
import Request from "common/Request";
import { parsePolicyNames } from "../api.js";

const loadPolicyNames = () =>
  ifCl.run("show api policy").then(parsePolicyNames);

const nameAsLabelAndValue = (names) =>
  names.map((name) => ({ label: name, value: name }));

const asOptions = (policies) => ({
  options: [{ value: "all", label: "All policies" }, ...policies],
});

const PolicyInput = ({ name, selected, onChange }) => (
  <Request during={loadPolicyNames().then(nameAsLabelAndValue).then(asOptions)}>
    {({ options = [] }) => (
      <SelectAutocomplete
        title="Policies"
        icon="folder_open"
        options={options}
        name={name}
        selected={selected}
        onChange= {(value)=> onChange(value, "policy")}
      />
    )}
  </Request>
);

export default PolicyInput;
